import React from 'react'
import { Link } from 'react-router-dom'
import dino from '../../assets/footer/trex.svg'

export const Footer = () => {
  return (
    <footer className="d-flex flex-wrap justify-content-center align-items-center py-3 bg-black">
        <p id="rarrFooter" className="col-md-4 mb-0 white-text ps-3 nav-link justify-content-center text-primary">&copy; RAARR {new Date().getFullYear()}</p>
        <a href="/" className="col-md-4 d-flex justify-content-center  mb-md-0 link-dark text-decoration-none pe-sm-2">
          <img src={dino} width={40} alt="RAARR" />
        </a>
        <ul className="nav justify-content-center ps-2">
          <li><Link to="terminos-de-uso" className="nav-link px-2">Términos de uso</Link></li>
          <li><Link to="politica-de-privacidad" className="nav-link px-2">Polìtica de privacidad</Link></li>
          {/* <li><a href="#" className="nav-link px-2 white-text">Contacto</a></li> */}
        </ul>
      </footer>
  )
}
